import React, {useState, useEffect} from 'react';
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from 'react-bootstrap/Modal';
import { displayTopicCompUtil, entryPoint } from '../../utils/topicUtils';
import PresentationEditor from './PresentationEditor';

const PresentationPage = ({topic, obj, edit}) => {

  const [modal, setModal] = useState(false);
  const [direction, setDirection] = useState("");
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
    
  const isMobile = width <= 768;
  const mode = edit? 'edit': 'preview';

  useEffect(()=>{

    const handleKeyDown = (event) => {
      switch (event.key) {
        case "ArrowUp":
          gotoNext();
          break;
        case "ArrowRight":
          gotoNext();
          break;
        case "ArrowDown":
          gotoPrev();
          break;
        case "ArrowLeft":
          gotoPrev()
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => { window.removeEventListener("keydown", handleKeyDown) };
      
  }, []);

  function gotoNext(){
    if(obj.Next != 'end'){
      window.location = `/topic/presentation/${topic.Slug}/${obj.Next}?mode=${mode}`;
    }
  }

  function gotoPrev(){
    if(obj.Prev == 'start'){
      window.location = `/topic/presentation-start/${topic.Slug}`;
    }else{
      window.location = `/topic/presentation/${topic.Slug}/${obj.Prev}?mode=${mode}`;
    }
  }

  const showModal = ()=>{
    setModal(true);
  }

  const closeModal = ()=>{
    setModal(false);
  }

  const styles = {   
    body:{
      display: 'flex',
      justifyContent: 'center',
      flex: 1,
      position: 'relative'
    },
    editBtn:{
      background: '#fff',
      color: '#666',
      width: 26,
      height: 26,
      fontSize: 13,
      padding: 2,
      textAlign: 'center',
      border: '1px solid #ccc',
      borderRadius: '100%',
      position: 'absolute',
      top: 0,
      right: 0,
      zIndex: 999,
      outline: 'none',
      boxShadow: 'none',
      transition: 'none',
    },
  }

  return(
    <div style={styles.body}>

      {edit && 
        <button onClick={showModal} style = {styles.editBtn}> 
          <FontAwesomeIcon icon={faCog} />
        </button>
      }

      {displayTopicCompUtil(obj, entryPoint.presentation)}

      <Modal size='md' show={modal} onHide={closeModal} backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title style={{fontSize:15}}>Editor</Modal.Title>
          <button type="button" onClick={closeModal} className="close">&times;</button>
        </Modal.Header>
        <Modal.Body> 
          <PresentationEditor obj={obj} close={closeModal} />
        </Modal.Body> 
      </Modal>

    </div>
  )
    
}

export default PresentationPage;